import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
})

export class BaseService {


    public apiURL = environment.baseAPI2;

    constructor() {
    }
}
